import React, { Component } from 'react'
import axios from 'axios';
import {NotificationManager} from 'react-notifications';
import { Link } from 'react-router-dom';
import Calendar from 'react-calendar'
import FormGroup from './FormGroup'
import Button from './Button'
import server from '../server'

class AsideRight extends Component {
  state = {
    loginForm: {},
    formRequestLoading: false,
    requestForm: {},
  }

  handleLoginFormChange = e => {
    const input = e.target;
    this.setState({
      loginForm: Object.assign(
          this.state.loginForm,
          { [input.name]: input.value }
        )
    });
  }
  handleLoginSubmit = e => {
    this.props.handleLoginSubmit(e, this.state.loginForm);
  }

  handleRequestFormChange = e => {
    const input = e.target;
    this.setState({
      requestForm: Object.assign(
          this.state.requestForm,
          { [input.name]: input.value }
        )
    });
  }
  handleRequestSubmit = e => {
    e.preventDefault();
    
    const queryData = new FormData(),
      forms = this.state.requestForm,
      cardItems = this.props.card && this.props.card.items;

    for( let k in forms )
      queryData.append(k, forms[k]);

    for( let i=0; i < cardItems.length; i++ )
      queryData.append('cardItems[]', cardItems[i].pagetitle);

    this.setState({ formRequestLoading: true });

    axios.post(server.uri+'request', queryData)
      .then(() => {
        for( let k in forms )
          forms[k] = '';

        this.setState({
          requestForm: forms,
          formRequestLoading: false,
        });
        NotificationManager.success('Ваш запрос прошел успешно', 'Спасибо');
      })
      .catch(() => {
        this.setState({ formRequestLoading: false });
        NotificationManager.error('Что то пошло не так... попробуйте позже', 'Ошибка');
      });
  }

  handleSubmit

  render() {
    if( this.props.width !== undefined && this.props.width[1] < 992 ) return '';

    const { portal_link } = this.props;

    const user = this.props.user,
      formLogin = this.state.loginForm,
      formLoginSettings = {
        required: true,
        handleChange: e => this.handleLoginFormChange(e),
      },
      formRequestSettings = {
        class: 'aside__wrap',
        handleChange: this.handleRequestFormChange,
      },
      card = this.props.card;
    
    return (
      <aside className="page-aside aside_right">
        <header>
          <form className={'login-form'+( this.props.formLoginLoading ? ' loading' : '' )+( user ? ' hide' : '' )} onSubmit={ this.handleLoginSubmit }>

            <img src="/assets/imgs/profile-picture.svg" alt="Profile avatar"/>

            <FormGroup type="email" name="email" value={formLogin.email} placeholder="email" {...formLoginSettings}/>
            <FormGroup type="password" name="password" value={formLogin.password} placeholder="пароль" {...formLoginSettings}/>

            <div className="loginform__btns">
              <Button theme="success">Войти</Button>
              <a href="login/forget">забыли пароль?</a>
            </div>
          </form>

          <div className={'profile'+( user ? '' : ' hide' )}>
          
            <img src="/assets/imgs/profile-picture.svg" alt="Profile avatar"/>

            <div className="profile__info">
              <p className="profile__name">{user && user.email}</p>
              <p className="profile__id">№{user && user.id}</p>
            </div>

            <div className="profile__btn">
              <Button theme="success" handleClick={ this.props.handleSignout }>Выйти</Button>
            </div>
          </div>
        </header>

        <section>
          <a className="aside__phone" href={`tel:${this.props.phone2Href}`}>{ this.props.phone2 }</a>
        </section>

        <section>
          <a className="aside__title aside__title_blue" href={ portal_link } target="_blank" rel="noopener noreferrer">Перейти в портал</a>
        </section>

        <section className="aside__calendar">
          <Calendar locale="ru-RU" value={ new Date() }/>
        </section>

        <section className="callback">
          <form className={this.state.formRequestLoading ? 'loading' : ''} onSubmit={ this.handleRequestSubmit }>

            <h3 className="aside__title aside__title_green">Оставить заявку</h3>

            <FormGroup name="name" value={ this.state.requestForm.name } placeholder="Ф.И.О." {...formRequestSettings}/>
            <FormGroup name="position" value={ this.state.requestForm.position } placeholder="Должность" {...formRequestSettings}/>
            <FormGroup name="company" value={ this.state.requestForm.company } placeholder="Компания" {...formRequestSettings}/>
            <FormGroup name="email" value={ this.state.requestForm.email } type="email" placeholder="Email" {...formRequestSettings}/>
            <FormGroup name="phone" value={ this.state.requestForm.phone } type="tel" placeholder="Контактный номер" required {...formRequestSettings}/>

            <div className="callback__btns">
              <Button theme="success">Отправить</Button>
            </div>
          </form>
        </section>

        <section>

          <h3 className="aside__title">Каталог / корзина запросов</h3>
          
          <div className="card_aside">
            <ul>
              { card.items.map( (v,i) => (
                <li key={i}>
                  <a href={ v.uri }>{ v.pagetitle }</a>
                  <Button theme="remove" handleClick={ () => this.props.handleCardRemove(v) }></Button>
                </li>
              ))}

              <li className={ 'card__empty'+(card.items.length ? ' hide' : '') }>
                <span>корзина пуста, </span>
                <Link to="/catalog">выбрать продукты</Link>
              </li>
            </ul>
          </div>
        </section>

        <footer>
          <div className="card_aside__btn">
            <Button theme="success" disabled={ !card.items.length }>Рассчитать запрос</Button>
          </div>
        </footer>
      </aside>
    );
  }
}
export default AsideRight;
